<template>
  <rest-list-page :page-title="pageTitle" :breadcrumbs="breadcrumbs">
    <template slot="actions">
      <el-button
        v-if="!readonly && $can('createProjectItem')"
        slot="controls"
        type="primary"
        icon="el-icon-circle-plus"
        @click="addRow"
      >
        {{ createTitle }}
      </el-button>
    </template>
    <template slot="list">
      <rest-list-editable
        :payload="fetchEndpoint"
        ref="rest-list-editable"
        :rules="rules"
        :add-endpoint="addEndpoint"
        :update-endpoint="updateEndpoint"
      >
        <rest-list-column prop="id" :title="$t('List_Field_Id')" :width="120" />
        <rest-list-column
          :editable="true"
          prop="name"
          :title="$t('List_Field_Name')"
          :filterable="true"
        />

        <rest-list-column-enum
          :editable="true"
          prop="identifier"
          :title="$t('List_Field_Identifier')"
          :enum="identifierList"
        />

        <rest-list-column-actions v-if="readonly">
          <template slot-scope="scope">
            <rest-list-action-view :route="rowViewRoute(scope.row)" />
          </template>
        </rest-list-column-actions>

        <rest-list-column-actions v-else :editable="true">
          <template slot-scope="scope">
            <rest-list-action-view :route="rowViewRoute(scope.row)" />
            <rest-list-action-delete
              v-if="$can('deleteProjectItem')"
              :name="scope.row.name"
              :endpoint="rowDeleteEndpoint(scope.row)"
            />
          </template>
        </rest-list-column-actions>
      </rest-list-editable>
    </template>
  </rest-list-page>
</template>

<script>
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionView from '@/common/components/rest/RestListActionView'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { listIdentifierLabel } from '@/modules/lists/enum/ListRecordEnums'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestListEditable from '@/common/components/rest/RestListEditable'
import RestListPage from '@/common/components/rest/RestListPageNew'
import { validateIdentifier } from '@/modules/lists/utils'
import _ from 'lodash'

export default {
  components: {
    RestListPage,
    RestListEditable,
    RestListColumn,
    RestListColumnEnum,
    RestListActionDelete,
    RestListActionView,
    RestListColumnActions
  },

  props: {
    suppression: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      listIdentifierLabel,
      rules: {
        identifier: {
          required: true
        },
        name: {
          required: true
        }
      }
    }
  },

  computed: {
    addEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `lists`
      })
    },
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    createTitle() {
      return this.suppression
        ? this.$t('Lists_CreateSuppressionList')
        : this.$t('Lists_CreateUserList')
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `lists`,
        params: {
          suppress: this.suppression ? 1 : 0
        }
      })
    },
    readonly() {
      return !this.$can('updateProjectItem')
    },

    features() {
      return this.$store.state.app.features || {}
    },

    identifierList() {
      const filtered = Object.keys(this.listIdentifierLabel).filter(key =>
        validateIdentifier(key, this.features)
      )
      return _.pick(this.listIdentifierLabel, filtered)
    },

    breadcrumbs() {
      return [
        { label: this.$t('ListItem_Breadcrumb_Data') },
        { label: this.$t('ListItem_Breadcrumb_Segments') },
        {
          label: this.suppression
            ? this.$t('ListItem_Breadcrumb_SuppressionLists')
            : this.$t('ListItem_Breadcrumb_UserLists'),
          route: projectRoute({
            name: this.suppression ? 'SuppressionLists' : 'UserLists'
          })
        }
      ]
    }
  },

  methods: {
    rowViewRoute(row) {
      return projectRoute({
        name: this.suppression ? 'SuppressionListItems' : 'UserListItems',
        query: { list_id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `lists/${row.id}`
      })
    },
    updateEndpoint(row) {
      return projectEndpoint({
        method: 'patch',
        url: `lists/${row.id}`
      })
    },
    addRow() {
      this.$refs['rest-list-editable'].addRow({
        suppress: this.suppression ? 1 : 0
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/lists/pages/ListsPage.vue